import { render } from "./FormRes.vue?vue&type=template&id=f30c3b9e"
import script from "./FormRes.vue?vue&type=script&lang=js"
export * from "./FormRes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__